import script from "./HeaderLanguage.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderLanguage.vue?vue&type=script&setup=true&lang=js"

import "./HeaderLanguage.vue?vue&type=style&index=0&id=fdb63fa2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fdb63fa2"]])

export default __exports__